import { render } from "./BonusSerial.vue?vue&type=template&id=6bfe0cb0&scoped=true"
import script from "./BonusSerial.vue?vue&type=script&lang=js"
export * from "./BonusSerial.vue?vue&type=script&lang=js"

import "./BonusSerial.vue?vue&type=style&index=0&id=6bfe0cb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bfe0cb0"]])

export default __exports__